



















import { Component, Prop, Vue } from "vue-property-decorator";
import Navigation from "@/components/Navigation.vue";
import { GameConfigType, GameType, UserType, PurchasesType } from "@/types";

@Component({ components: { Navigation } })
export default class App extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: false, default: null }) game!: GameType | null;
  @Prop({ required: true }) initializing!: boolean;
  @Prop({ required: false }) purchases?: PurchasesType;
  @Prop({ required: false, default: null }) user!: UserType | null;

  get showGame() {
    return (
      this.$route.name === "Main" && this.user && this.game && !!this.game.players[this.user.uid]
    );
  }
}
